module.exports = __webpack_public_path__ + "site/img/zh.b830a16c.png";